<template>
  <div>
    <div
      class="destination-container"
      :style="{ 'min-width': minWidth }"
    >
      <img
        class="destination-icon"
        :src="destinationImage"
        @click="$emit('selectedDestination', destination)"
        v-on:mouseover="hover"
        v-on:mouseout="hoverOut"
        :class="{ 'destination-icon_clickable': !canUpdate }"
      />
      <!-- <div class="destination-label">
        {{ destination.label || destination.id }}
      </div> -->
    </div>
    <div
      v-if="selected && (canUpdate || showUE)"
      class="inline"
    >
      <div
        class="popover"
        v-if="showPopup"
        transition="fade"
        v-on:mouseover="hoverOnPopover"
        v-on:mouseout="hoverOffPopover"
      >
        <div class="popover-text">{{ UEText }}</div>
      </div>
    </div>
    <div
      v-if="showInput"
      class="inline"
    >
      <!--
        DEPRECATED
        <div class="data-input">
        <label>UE:</label>
        <number-input
          v-model="audience_size"
          :min="0"
          separator=","
          :readOnly="false"
        />
      </div> -->
      <div
        v-if="showMRM_ID"
        class="data-input"
      >
        <label>MRM ID:</label>
        <input
          type="text"
          v-model="mrmId"
          class="mrmId-input"
          @keypress="validateNumber"
        />
      </div>
    </div>
  </div>
</template>

<script>
  import { DESTINATIONS } from '@/appLogic/targets/Constants'
  import NumberInput from '../../../../components/common/inputs/NumberInput.vue'

  export default {
    components: {
      NumberInput,
    },
    props: {
      destination: {
        type: Object,
        default: null,
      },
      selected: {
        type: Boolean,
        default: false,
      },
      canUpdate: {
        type: Boolean,
        default: false,
      },
      showUE: {
        type: Boolean,
        default: false,
      },
      UE: {
        type: Number,
        default: 0,
      },
      MRM_ID: {
        type: String,
        default: '',
      },
      minWidth: {
        type: String,
        default: '120px',
      },
      showMRM_ID: {
        type: Boolean,
        default: true,
      },
    },
    data() {
      return {
        showPopup: false,
        timer: '',
        cursorOnPopover: false,
        audience_size: 0,
        mrmId: '',
      }
    },
    methods: {
      hover() {
        let vm = this
        this.timer = setTimeout(function () {
          vm.showPopover()
        }, 200)
      },
      hoverOut() {
        let vm = this
        clearTimeout(vm.timer)
        this.timer = setTimeout(function () {
          if (!vm.cursorOnPopover) {
            vm.closePopover()
          }
        }, 200)
      },
      hoverOnPopover() {
        this.cursorOnPopover = true
      },
      hoverOffPopover() {
        this.cursorOnPopover = false
        this.hoverOut()
      },
      showPopover() {
        this.showPopup = true
      },
      closePopover() {
        this.showPopup = false
      },
      validateNumber(event) {
        let keyCode = event.keyCode
        if (keyCode < 48 || keyCode > 57) {
          event.preventDefault()
        }
      },
    },
    computed: {
      destinationImage() {
        return this.selected && !this.destination.isDisabled
          ? this.destination.img.selected
          : this.destination.img.default
      },
      UEText() {
        return this.audience_size !== null ? 'UE: ' + Number(this.audience_size).toLocaleString('en') : 'UE: 0'
      },
      isVizio() {
        return this.destination.id === DESTINATIONS.VIZIO
      },
      isDTV() {
        return this.destination.id === DESTINATIONS.DIRECTV
      },
      isCanoeLinear() {
        return this.destination.id === DESTINATIONS.CANOE_LINEAR
      },
      isCanoeVOD() {
        return this.destination.id === DESTINATIONS.CANOE_VOD
      },
      showInput() {
        return this.selected && this.isCanoeLinear && (this.canUpdate || this.showUE)
      },
    },
    mounted() {
      this.audience_size = this.UE
      this.mrmId = this.MRM_ID
    },
    watch: {
      // DEPRECATED with 3158
      audience_size(newVal, oldVal) {
        if (oldVal !== newVal && this.isCanoeLinear) {
          this.$emit('UEChanged', this.audience_size)
        }
      },
      mrmId(newVal, oldVal) {
        if (oldVal !== newVal && this.isCanoeLinear) {
          this.$emit('MRMIDChanged', this.mrmId)
        }
      },
    },
  }
</script>

<style lang="scss" scoped>
  .destination-container {
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    flex-wrap: wrap;
    text-align: center;
  }

  .destination-icon {
    width: 76px;
    height: 76px;
    margin: 0px 0px;
  }

  .destination-icon_clickable {
    cursor: pointer;
  }

  .destination-label {
    font-weight: bold;
    margin: auto;
    width: 100%;
    padding: 2px;
  }

  .inline {
    position: relative;
    margin: 20px auto;
  }

  .popover {
    position: absolute;
    background: #616161;
    border: 1px solid whitesmoke;
    box-shadow:
      0 6px 6px rgba(16, 16, 16, 0.04),
      0 6px 6px rgba(0, 0, 0, 0.05);
    border-radius: 4px;
    z-index: 999;
    padding: 0px 8px 0px 8px;
    height: 24px;
    min-width: 200px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
  }

  .popover-text {
    font-family: 'Montserrat', sans-serif;
    font-size: 14px;
    color: white;
    margin: 2px 0px 2px 0px;
  }

  .data-input {
    position: relative;
    padding: 0px 8px 0px 8px;
    height: 24px;
    top: 50%;
    left: 50%;
    transform: translate(-65%, -50%);
    text-align: right;
    min-width: 200px;
    margin: 20px 0px 0px 0px;
  }

  .mrmId-input {
    text-align: right;
    width: 90px;
  }
</style>



// WEBPACK FOOTER //
// MVPD.vue?73fbee46